import { SendTrackingRequest, trackFormHandler } from "../lib/api/tracking/forms/t";

interface FormAnalytics {
  trackFormEvent: ({ id, event }: SendTrackingRequest) => void;
}

const useFormAnalytics = (isPreview: boolean): FormAnalytics => {
  if (isPreview)
    return {
      trackFormEvent: () => { console.log("trackFormEvent skipped") },
    };

  const trackFormEvent = ({ id, event }: SendTrackingRequest) => {
    trackFormHandler({ id, event });
  };
  return { trackFormEvent };
};

export default useFormAnalytics;
